import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Close } from '@mui/icons-material';
import { Divider, Grid, IconButton } from '@mui/material';

import ConfirmationDialog from 'commons/components/ConfirmationDialog/ConfirmationDialog.component';
import { InventoryAdjustment } from 'commons/types';
import {
  removeInventoryAdjustment,
  getInventoryAdjustments,
  createInventoryAdjustment,
} from 'redux-stores/actions';
import { setSelectedInventoryAdjustment } from 'redux-stores/reducers/inventoryAdjustment.reducer';
import { AppDispatch } from 'redux-stores/store';

import S from './styles/AdjustmentListPage.styles';

const InventoryAdjustmentDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] =
    useState<InventoryAdjustment | null>(null);
  const inventoryAdjustments = useSelector(
    (state: any) => state.inventoryAdjustment.inventoryAdjustmentList,
  );

  useEffect(() => {
    dispatch(getInventoryAdjustments());
  }, [dispatch]);

  const onDeleteModalOpen = (document: InventoryAdjustment) => {
    setSelectedDocument(document);
    setOpenDeleteModal(true);
  };

  const handleDeleteConfirmation = async () => {
    if (selectedDocument) {
      await dispatch(
        removeInventoryAdjustment(
          encodeURIComponent(selectedDocument.document_number),
        ),
      );
      setOpenDeleteModal(false);
      dispatch(getInventoryAdjustments());
    }
  };

  const handleModalClose = () => {
    setOpenDeleteModal(false);
  };

  const handleCreateNewAdjustment = async () => {
    await dispatch(createInventoryAdjustment());
    dispatch(getInventoryAdjustments());
  };

  const onEditDetails = (adjustment: InventoryAdjustment) => {
    dispatch(setSelectedInventoryAdjustment(adjustment));
    navigate('/inventory-adjustment/details');
  };

  const renderAdjustmentList = (
    adjustments: InventoryAdjustment[],
  ): React.JSX.Element[] =>
    adjustments.map((adjustment) => (
      <Grid container key={adjustment.document_number}>
        <S.FlexGrid item xs={12} container style={{ padding: 24 }}>
          <S.FlexGrid>
            <IconButton
              style={{ marginRight: 8 }}
              onClick={() => onDeleteModalOpen(adjustment)}
            >
              <Close fontSize="small" />
            </IconButton>
            <S.ListGrid item>
              Document Number: {adjustment.document_number}
            </S.ListGrid>
          </S.FlexGrid>
          <Grid item xs={4}>
            <S.SecondaryButton onClick={() => onEditDetails(adjustment)}>
              Edit Details
            </S.SecondaryButton>
          </Grid>
        </S.FlexGrid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
    ));

  return (
    <div>
      <S.ContentWrapper>
        {renderAdjustmentList(inventoryAdjustments)}
      </S.ContentWrapper>
      <S.StickyFooterWrapper>
        <S.PrimaryButton onClick={handleCreateNewAdjustment}>
          Create New Inventory Adjustment
        </S.PrimaryButton>
      </S.StickyFooterWrapper>

      <ConfirmationDialog
        title="DELETE INVENTORY ADJUSTMENT"
        content={`Are you sure you want to delete document number: <b>${selectedDocument?.document_number}</b>?`}
        openModal={openDeleteModal}
        onClose={handleModalClose}
        onConfirm={handleDeleteConfirmation}
      />
    </div>
  );
};

export default InventoryAdjustmentDetailPage;
